import staff from './staff'

export default [
  ...staff,
]
